import { render, staticRenderFns } from "./problemThree.vue?vue&type=template&id=70dec064&scoped=true"
import script from "./problemThree.vue?vue&type=script&lang=js"
export * from "./problemThree.vue?vue&type=script&lang=js"
import style0 from "./problemThree.vue?vue&type=style&index=0&id=70dec064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dec064",
  null
  
)

export default component.exports